(function () {
    function getCardGrids(scope) {
        if (scope && scope.id === 'resourcesGrid') {
            return [scope];
        }
        if (scope && scope.classList && scope.classList.contains('resources-grid')) {
            return [scope];
        }
        const root = scope && scope.querySelectorAll ? scope : document;
        return Array.from(root.querySelectorAll('#resourcesGrid, .resources-grid'));
    }

    function equalizeCardHeights(scope) {
        getCardGrids(scope).forEach(function (grid) {
            const cards = Array.from(grid.querySelectorAll('.resource-card:not([hidden])'));
            if (!cards.length) {
                return;
            }

            cards.forEach(function (card) {
                card.style.height = 'auto';
                card.style.minHeight = '';
            });

            const rows = [];
            cards.forEach(function (card) {
                const top = card.offsetTop;
                let row = rows.find(function (entry) {
                    return Math.abs(entry.top - top) <= 2;
                });
                if (!row) {
                    row = { top: top, cards: [] };
                    rows.push(row);
                }
                row.cards.push(card);
            });

            rows.forEach(function (row) {
                if (row.cards.length < 2) {
                    return;
                }

                let maxHeight = 0;
                row.cards.forEach(function (card) {
                    maxHeight = Math.max(maxHeight, card.offsetHeight);
                });

                if (maxHeight <= 0) {
                    return;
                }

                row.cards.forEach(function (card) {
                    card.style.height = maxHeight + 'px';
                    card.style.minHeight = maxHeight + 'px';
                });
            });
        });
    }

    function updateExcerpts(root) {
        const scope = root && root.querySelectorAll ? root : document;
        scope.querySelectorAll('.resource-card__excerpt').forEach(function (excerpt) {
            excerpt.style.webkitLineClamp = '';
        });
        equalizeCardHeights(root);
    }

    function scheduleUpdate(root) {
        window.requestAnimationFrame(function () {
            updateExcerpts(root);
        });
    }

    function observeCards() {
        if (typeof ResizeObserver === 'undefined') {
            return;
        }

        const observer = new ResizeObserver(function () {
            scheduleUpdate(document);
        });

        document.querySelectorAll('.resource-card').forEach(function (card) {
            observer.observe(card);
        });
    }

    function init() {
        scheduleUpdate(document);
        observeCards();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.addEventListener('resize', function () {
        scheduleUpdate(document);
    });

    window.ResourceCardExcerpts = {
        update: scheduleUpdate,
    };
}());
